import React from "react";
import "./NumBox.scss";

const NumBox = (props) => { 
    return(
        <div className="counter" style={{ backgroundColor : props.bgcolor}}>
            <div className="num">{props.num}+</div>
            <div className="title">{props.title}</div>
        </div>
    );
}

export default NumBox;